<!-- <material-navbar [hideRegisterButton]="state.mode === 'pricing'" class="nav"></material-navbar> -->
<material-navbar [container]="true" [menuPosition]="
    settings.get('vebto.navbar.defaultPosition', 'homepage-navbar')
  " class="login-button-accent"></material-navbar>

<div class="bg-wrapper">
  <div class="container-fluid header">
    <div class="col-sm-12 heading">
      <div class="moneyback">
        <img src="/client/assets/images/moneyback.png" />
      </div>
      <div class="pricing-header">
        <h1 class="text">Pricing for brands and businesses of all sizes</h1>
        <p class="sub-text">
          Connect to your audience with branded links, QR Codes, and a
          Link-in-bio that will get their attention.
        </p>
      </div>
    </div>
    <div class="col-sm-12 sub-heading">
      <div class="annual-slide">
        <mat-tab-group (selectedTabChange)="selectedTabValue($event,'year')">
          <mat-tab label="Month" name="month"></mat-tab>
          <mat-tab label="Year" name="year"></mat-tab>
        </mat-tab-group>
      </div>
      <div class="currency-slide">
        <div class="toggle">
          <div class="example-section">
            <mat-tab-group (selectedTabChange)="selectedTabValue($event,'currency')">
              <mat-tab label="INR"></mat-tab>
              <mat-tab label="USD"></mat-tab>
              <mat-tab label="EUR"></mat-tab>
              <mat-tab label="GBP"></mat-tab>
              <mat-tab label="AUD"></mat-tab>
              <mat-tab label="CAD"></mat-tab>
              <mat-tab label="JPY"></mat-tab>
            </mat-tab-group>
          </div>
        </div>
      </div>
      <div class="header-img">
        <img src="/client/assets/images/header-img.png" />
      </div>
    </div>
  </div>

  <div class="w-100 vh-100 border rounded-1 background">
    <!-- <iframe [src]="url" class="frame1 m-5" frameborder="0" style="border:0" allowfullscreen></iframe> -->
  </div>

  <div class="container-fluid pricing-box">
    <mat-horizontal-stepper class="container main-content" [linear]="false">
      <ng-template matStepperIcon="edit">
        <mat-icon svgIcon="edit" class="size-16"></mat-icon>
      </ng-template>

      <mat-step [label]="'Subscription plan' | trans" [completed]="!!(state.initialPlan$ | async)">
        <select-plan-panel [year]="defaultYear" [cur]="defaultCurrency" (selected)="nextStep()"></select-plan-panel>
      </mat-step>

      <mat-step [label]="'Subscription duration' | trans" [completed]="!!(state.selectedPlan$ | async)">
        <select-plan-period-panel [showSidebar]="true" (selected)="buy()"></select-plan-period-panel>
      </mat-step>

      <mat-step [label]="'Address' | trans" [completed]="false">
        <div class="step-container payment-step">
          <div class="left-col">
            <form (ngSubmit)="handleAddressSubmit()">
              <div id="address-element"></div>
              <div class="actions">
                <button mat-button matStepperPrevious trans>Back</button>
                <button mat-raised-button color="accent" type="submit">
                  Proceed To Payment
                </button>
              </div>
            </form>
          </div>
        </div>
      </mat-step>

      <mat-step [label]="'Payment' | trans" [completed]="false">
        <div class="step-container payment-step">
          <div class="left-col">
            <form (ngSubmit)="handleSubmit()">
              <div id="payment-element"></div>
              <div id="error-message"></div>
              <div class="actions">
                <button mat-button (click)="goToPeriodStep()" type="button">Back</button>
                <button mat-raised-button color="accent" type="submit">
                  Proceed To Payment
                </button>
              </div>
            </form>
          </div>
        </div>
      </mat-step>

      <!-- <mat-step [label]="'Payment' | trans" [completed]="false" *ngIf="state.mode === 'subscribe'">
        <div class="step-container payment-step">
          <div class="left-col">
            <create-subscription-panel [plan]="state.selectedPlan$ | async" (loading)="loading$.next($event)"
              (completed)="onCompleted()"></create-subscription-panel>
          </div>

          <upgrade-page-aside [plan]="state.selectedPlan$ | async" class="right-col"></upgrade-page-aside>
        </div>

        <p class="legal-info" *ngIf="state.selectedPlan$ | async as plan" trans [transValues]="{
            siteName: settings.get('branding.site_name'),
            intervalCount: plan.interval_count > 1 ? plan.interval_count : '',
            intervalName:
              plan.interval_count > 1 ? plan.interval + 's' : plan.interval
          }">
          You authorise :siteName to charge you automatically every
          :intervalCount :intervalName, until you cancel your subscription. You
          consent to get access to your :siteName subscription immediately, and
          acknowledge that refunds are only available within 14 days and
          provided you haven't accessed :siteName. You will be able to cancel
          your subscription at any time from your profile page.
        </p>
      </mat-step> -->
    </mat-horizontal-stepper>
  </div>
  <div class="container">
    <h2 class="info-msg">Custom API Plans are available for Big organizations, Please email to <a href="mailto:support@jio.sh">support@jio.sh</a></h2>
  </div>
  <features-table></features-table>
</div>



<div class="container-fluid contact-div">
  <contact-widget></contact-widget>
</div>

<loading-indicator class="overlay" [isVisible]="loading$ | async"></loading-indicator>
<app-footer class="container"></app-footer>